<template>
    <div class="reel flex overflow-hidden flex-col xm:flex-row" v-if="isLoaded">
        <ReelPlayer :namespace="namespace" :autoplay="autoplay" />

        <div v-if="showClipList" class="reel-right relative">
            <ClipList :namespace="namespace" />
        </div>
    </div>

    <div v-else class="flex justify-center items-center">
        <Spinner />
    </div>
</template>

<script>
    import ReelPlayer from './ReelPlayer'
    import ClipList from './ClipList'
    import Spinner from '@/components/Spinner'
    import { mapActions, mapState, mapGetters } from '@/utils/namespaced-mappings'
    import first from 'lodash/first'
    import reelPlayerModule from '@/store/modules/reelPlayer'

    let nextId = 1

    export default {
        components: {
            ReelPlayer,
            ClipList,
            Spinner,
        },

        props: {
            projectId: { required: true },
            showClipList: { type: Boolean, default: true },
            autoplay: { type: Boolean, default: false },
        },

        data() {
            const componentId = nextId++
            const namespace = `reelEditor${componentId}`

            this.$store.registerModule(namespace, reelPlayerModule)
            
            return {
                componentId,
                namespace,
            }
        },

        computed: {
            ...mapGetters(['isLoaded', 'clipsInPlayOrder']),
        },

        created() {
            this.loadProject(this.projectId)
        },

        beforeDestroy() {
            this.resetState()
        },

        methods: {
            ...mapActions(['loadProject', 'resetState', 'jumpToClip'])
        }
    }
</script>

<style lang="scss" scoped>
    .reel-right {
        flex-basis: 33%;
        // @media screen and (min-width: 768px) { flex-basis: 30% }
        // @media screen and (min-width: 992px) { flex-basis: 33% }
        // @media screen and (min-width: 1200px) { flex-basis: 25% }
    }
</style>